var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed-bottom"},[_c('footer',{staticClass:"footer main-color-background"},[_vm._v("\n        © 2021 - Sition | version: "+_vm._s(_vm.version)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }